<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const { t } = useI18n();

const props = defineProps<{
    isShow: boolean;
    questions: string[];
    language: string;
}>();

const selectQuestion = (question: string) => {
    if (chatStore.isStreaming) {
        return;
    }

    const trimmed = question?.trim();
    if (!trimmed) {
        return;
    }

    chatStore.search(trimmed);
};
</script>

<template>
    <!-- フルスクリーン時: カード枠なし・横並びフロー -->
    <div v-if="props.isShow && props.questions.length > 0 && chatStore.windowExtend"
        class="mt-2 flex flex-wrap gap-2 justify-end">
        <button v-for="question in props.questions" :key="question" type="button"
            class="text-left bg-white border border-solid border-gray-300 rounded-2xl px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
            @click="selectQuestion(question)" :disabled="chatStore.isStreaming"
            :class="chatStore.createLanguageClass(props.language)">
            {{ question }}
        </button>
    </div>

    <!-- 通常時: カード形式 -->
    <div v-else-if="props.isShow && props.questions.length > 0 && !chatStore.windowExtend"
        class="mt-2 rounded-2xl border border-solid border-gray-200 bg-white px-4 py-3">
        <div class="flex items-center gap-2 mb-3">
            <span
                class="flex items-center justify-center w-6 h-6 rounded-full bg-gray-500 text-white text-xs font-bold flex-shrink-0">
                ?
            </span>
            <span class="text-sm font-semibold text-gray-600"
                :class="chatStore.createLanguageClass(props.language)">
                {{ t('relatedQuestions') }}
            </span>
        </div>
        <div class="flex flex-col gap-2">
            <button v-for="question in props.questions" :key="question" type="button"
                class="text-left bg-white border border-solid border-gray-300 rounded-2xl px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
                @click="selectQuestion(question)" :disabled="chatStore.isStreaming"
                :class="chatStore.createLanguageClass(props.language)">
                {{ question }}
            </button>
        </div>
    </div>
</template>
